module.exports = __webpack_public_path__ + "static/media/live31_08_2024.d900593a.jpg";